<template>
  <div>
    <MainNavigation page-name="My Class" :routeIndex="routeIndex"/>
    <NotificationBar msg-text="Add your student list" />
    <div>
      <h2>Class Info</h2>
      <ClassItem
        v-if="currentClass"
        :editMode="false"
        :classItem="currentClass"
        :itemType="'static'"
      />
    </div>
    <hr />
    <div class="number-students-list">
      <!-- <h2>Add Students</h2>
      <div class="update-student-list-container-upload flex-container-row">
        <button>Upload File</button>
        <span>
          <em
            >Have a .csv or .xsl file of students?<br />List student names in
            column one, and student IDs in column 2.<br
          /></em>
        </span>
      </div> -->
      <h2>Enter Student Names</h2>
      <div class="flex-container-row">
        <div class="input-counter">
          <span class="material-icons-round button" @click="removeAStudent"
            >remove_circle</span
          >
          <input
            class="clock__input--number"
            type="number"
            v-model="studentNumber"
            @change="updateStudentCount"
            id="time-limit-number"
          />
          <span class="material-icons-round" @click="addAStudent"
            >add_circle</span
          >
        </div>
        <span><em>Enter number of students</em></span>
      </div>
    </div>
    <p
      v-if="validArray.filter((item) => item > 0).length != 0"
      style="display: flex; font-weight: bold; font-width: 16px; color: #eb5757"
    >
      See errors below.
    </p>
    <div
      v-if="validArray.filter((item) => item > 0).length != 0"
      :class="{ error: validArray.filter((item) => item > 0).length != 0 }"
      style="padding: 1rem"
    >
      <p
        v-if="validArray.filter((item) => item >= 1).length != 0"
        style="display: flex; align-items: center"
      >
        <img
          src="@/assets/error_outline_24px.svg"
          style="padding-right: 0.5rem"
        />
        Student must have unique names. Please remove duplicate names.
      </p>
      <p
        v-if="validArray.filter((item) => item == 2).length != 0"
        style="display: flex; align-items: center"
      >
        <img
          src="@/assets/error_outline_24px.svg"
          style="padding-right: 0.5rem"
        />
        For students with identical names, add a unique nickname.
      </p>
    </div>
    <ul class="student-list">
      <li
        v-for="(student, index) in classList"
        :key="index"
        :class="{ error: validArray[index] != 0 }"
      >
        <!-- <p v-if="validArray[index] == 0">No Error</p>
        <p v-else-if="validArray[index] == 1">Error 1</p>
        <p v-else>Error 2</p> -->
        <div class="student-form">
          <h4>Student {{ index + 1 }}</h4>
          <span
            class="material-icons-round button"
            @click="removeStudent(index)"
            >remove_circle</span
          >
        </div>
        <input
          type="text"
          placeholder="Full Name"
          v-model="student.studentName"
        />
        <div v-if="student.isNickNameOpen">
          <div class="student-form">
            <h4>Nickname</h4>
            <span
              class="material-icons-round button"
              @click="closeNickname(student)"
              >remove_circle</span
            >
          </div>
          <div class="nickname-form">
            <input
              type="text"
              placeholder="Nickname"
              v-model="student.studentNickname"
            />
          </div>
        </div>
        <button
          style="margin: 1rem 0"
          class="add-nickname-button"
          v-if="!student.isNickNameOpen"
          @click="student.isNickNameOpen = true"
        >
          <span class="material-icons-round">add_circle</span>
          Add a Nickname
        </button>
      </li>
    </ul>

    <div class="add-student" style="margin-bottom: 2rem">
      <button @click="addAStudent()" class="add-student-button">
        <span class="material-icons-round">add_circle</span>
        <span>Add a Student</span>
      </button>
    </div>

    <button class="save-button" @click="checkIfValid()">Save</button>
    <div class="write-student-name-container" style="display: none">
      <p>Add your student list here with a line break after name:</p>
      <textarea
        v-model="studentEntry"
        placeholder="Add one student per line"
        rows="20"
      ></textarea>
      <button class="save-button" @click="checkIfValid()">Save</button>
    </div>
    <!-- <p style="white-space: pre-line">{{ allStudents }}</p> -->
    <!-- <p>{{ $store.state.currentClass.classInfo.nickname }}</p> -->
  </div>
</template>

<script>
import MainNavigation from "../components/MainNavigation.vue";
import NotificationBar from "../components/NotificationBar.vue";
import ClassItem from "../components/ClassItem.vue";

export default {
  name: "StudentList",
  components: {
    MainNavigation,
    NotificationBar,
    ClassItem,
  },
  props: ["name", "routeIndex"],
  data() {
    return {
      studentEntry: null,
      studentNumber: 0,
      showStudentList: true,
      classList: [],
    };
  },
  computed: {
    allClasses() {
      return this.$store.state.allClasses;
    },
    currentClass() {
      const result = this.$store.state.allClasses.filter((response) => {
        return response.classInfo.nickname === this.$route.params.name;
      });
      // console.log(result, this.$route.params.name);
      return result[0];
    },
    allStudents() {
      return this.$store.state.studentList;
    },
    validArray() {
      let tempArray = [];
      for (let index = 0; index < this.classList.length; index++) {
        tempArray[index] = 0;
      }
      for (
        let firstIndex = 0;
        firstIndex < this.classList.length;
        firstIndex++
      ) {
        let firstStudent = this.classList[firstIndex];
        for (
          let secondIndex = 0;
          secondIndex < this.classList.length;
          secondIndex++
        ) {
          let secondStudent = this.classList[secondIndex];
          if (
            firstIndex != secondIndex &&
            firstStudent.studentName != "" &&
            secondStudent.studentName != "" &&
            firstStudent.studentName == secondStudent.studentName
          ) {
            if (
              firstStudent.studentNickname != "" &&
              secondStudent.studentNickname != "" &&
              firstStudent.studentNickname == secondStudent.studentNickname
            ) {
              // Duplicate Names / Duplicate Nicknames
              tempArray[firstIndex] = 2;
              tempArray[secondIndex] = 2;
            } else if (
              firstStudent.studentNickname != secondStudent.studentNickname
            ) {
              // Duplicate Names / Different Nicknames
              tempArray[firstIndex] = 0;
              tempArray[secondIndex] = 0;
            } else {
              // Duplicate Names / No Nicknames
              tempArray[firstIndex] = 1;
              tempArray[secondIndex] = 1;
            }
          }
        }
      }
      return tempArray;
    },
  },
  methods: {
    checkIfValid: function () {
      let flag = true;
      if (this.validArray.filter((item) => item > 0).length != 0) flag = false;
      if (this.classList.filter((item) => item.studentName == "") != 0)
        flag = false;
      if (this.classList.length == 0) flag = false;
      if (flag) this.saveClass();
    },
    saveClass: function () {
      this.$store.commit("SEND_MESSAGE", {
        data: {
          studentList: this.classList,
          classId: this.$store.state.currentClass.classId,
        },
        opCode: this.$store.state.opCodes.SetStudentList,
      });
      this.$store.commit("SEND_MESSAGE", {
        data: this.currentClass.classId,
        opCode: this.$store.state.opCodes.PastSessionsCount,
      });
      this.$router.push({
        name: "class-info",
        params: { name: this.currentClass.classInfo.nickname },
      });
    },
    removeAStudent() {
      if (this.studentNumber === 0) return;
      this.studentNumber--;
      this.classList.splice(this.studentNumber, 1);
    },
    addAStudent() {
      this.studentNumber++;
      this.classList.push({
        isNickNameOpen: false,
        studentName: "",
        studentNickname: "",
      });
    },
    updateStudentCount() {
      var count = this.studentNumber;
      if (count < this.classList.length) {
        this.classList.splice(count, this.classList.length - count);
      } else {
        var countDiff = count - this.classList.length;
        for (let i = 0; i < countDiff; i++) {
          this.classList.push({
            isNickNameOpen: false,
            studentName: "",
            studentNickname: "",
          });
        }
      }
    },
    closeNickname(student) {
      student.isNickNameOpen = false;
      student.studentNickname = "";
    },
    removeStudent(index) {
      this.classList.splice(index, 1);
      this.studentNumber--;
    },
  },
};
</script>

<style lang="scss">
/* /* ../assets/scss/_student-list.scss */
</style>